<template>
  <div>
    <div class="w-full pb-4 xl:pb-8">
      <Navigation :step="2" />

      <div v-if="!redemptionUltimateFailureReason" class="w-full">
        <div class="container">
          <div class="text-sm xl:text-xl">
            <h1 class="pb-3 text-lg font-bold leading-tight xl:text-4xl xl:pb-4">
              {{ $t('pages.redemption.title') }}
            </h1>
            <p v-if="!loading || errors.length" class="leading-tight">
              {{ $t('pages.redemption.subtitle') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="redemptionUltimateFailureReason" class="container pt-6 border-t xl:pt-8 border-sw_gray-300">
      <p class="max-w-sm pt-6 mx-auto text-center xl:pt-12">
        {{ $t(`errors.type.${errors[0]}.title`, brandInfo) }}
        <br>
        {{ $t(`errors.type.${errors[0]}.description`, brandInfo) }}
      </p>
      <p class="max-w-sm pt-2 mx-auto text-center">
        {{ $t('components.payment.beforeCancellationRedirect', brandInfo) }}
      </p>
    </Loading>

    <div v-else-if="redemption.id" class="w-full flex-1-0-auto">
      <div class="container">
        <div class="w-full max-w-2xl m-0">
          <RouterView />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Redemption from '~psp-pages/base/redemption/redemption.ts'

import Navigation from '~app/psp/swiss/navigation.vue'
import Summary from './summary.vue'
import Loading from '~brand-components/swiss/loading/loading.vue'

export default Redemption.extend({
  components: {
    Loading,
    Navigation,
    Summary,
  },
})
</script>
